export default __webpack_public_path__ + "static/hero-pattern-dark3-14f82fbb94f75fe70f1ccf3283db8aec.svg";